
/**
 * メールアドレスが正しい形式になっているかをチェックする関数
 * 形式：RFC準拠かつ@の前に3文字以上
 * 　vue.js公式でも使われている正規表現を採用
 * 　https://qiita.com/komekami0131/items/7a7834ea63eb0f22d161
 * 　https://jp.vuejs.org/v2/cookbook/form-validation.html#%E3%82%AB%E3%82%B9%E3%82%BF%E3%83%A0%E3%83%90%E3%83%AA%E3%83%87%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3%E3%81%AE%E5%88%A9%E7%94%A8
 *
 * @param mailAddress チェックしたいメールアドレス
 * @return {boolean}
 */
export function isValidMailAddress(mailAddress) {
    const regex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regex.test(mailAddress) && mailAddress.indexOf("@") >= 3;
};

/**
 * 文字列が指定した文字数以上かをチェックする関数（必要になればmaxLengthも入れる）
 * @param {string} value - チェックしたい文字列
 * @param {number} minLength - 確認したい文字数
 * @return {boolean}
 */
export function isValidTextLength (value, minLength) {
    return value.length >= minLength
}

/**
 * 半角英数字の文字列かチェック
 * @param {string} value - チェックしたい文字列
 * @return {boolean}
 */
export function isIncludeInvalidPasswordLetter(value) {
    const reg = new RegExp(
        /^[a-zA-Z\d]*$/
    )
    return !reg.test(value)
}

/**
 * 英字を含むかチェックする関数
 * @param {string} value - チェックしたい文字列
 * @return {boolean}
 */
export function isIncludeAlphabet(value) {
    const reg = new RegExp(/[a-zA-Z]/g)
    return reg.test(value)
}

/**
 * 数字を含むかチェックする関数
 * @param {string} value - チェックしたい文字列
 * @return {boolean}
 */
export function isIncludeNumber(value) {
    const reg = new RegExp(/\d/g)
    return reg.test(value)
}
